import { lazy } from 'react'

const PermissionList = lazy(() => import('@/pages/Permission/List'))

const permissionRoute = {
  path: 'permission',
  meta: { title: '权限管理', icon: 'SafetyOutlined', permission: 'permission:view' },
  children: [
    {
      path: 'list',
      element: <PermissionList />,
      meta: { title: '权限列表', permission: 'permission:list' },
    },
  ],
}

export default permissionRoute
